import React, { useEffect, useState } from "react";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import { Btn } from "../../../AbstractElements";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useActive_InActiveStatus, useAddSurvey,useGetCategoryType,useGetOutletTypes,useSurveyConfiguration,useUpdateSurvey,} from "../hook/useSurvey";
import { useGetOrgUnitsData } from "../../Configuration/Grade Master/hooks/useGradeMaster";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import { FaTrash } from "react-icons/fa";


interface rowInteface{
    StartDate?:string,
    SurveyId?:number,
    name?: string,
    SurveyName?: string,
    Status?: string,
    EndDate?:string,
    AudienceType?: string,
    MediaId?:string,
    Multiple?:string | boolean,
    survey_category_name?:string,
    ShortCode?:string,
    OutletTypeId?:string,
    Orgunitid:string,
    SurveyCatid?:number
}

type ProductCardProps = {
  setIsModalOpen?: any;
  isModalOpen?: any;
  toggleModal?: any;
  title?: any;
  checkAddEditStatus?: any;
  setCheckAddEditStatus?: any;
  Surveyrow?:rowInteface
};
const SurveyAddAndEditModal: React.FC<ProductCardProps> = ({
  setIsModalOpen,
  isModalOpen,
  title,
  Surveyrow,
  checkAddEditStatus,
  setCheckAddEditStatus,
}) => {
  const { data, isLoading, isSuccess } = useGetOutletTypes({ enable: true });
  const {data: StatusData,isLoading: statusLoading,isSuccess: StatusSuccess} = useActive_InActiveStatus({ enable: true });  
  const { data: orgUnitsData } = useGetOrgUnitsData({ enable: true });

  const {mutate:AddSurvey} = useAddSurvey();
  const {mutate:UpdateSurvey} = useUpdateSurvey()

  const formattedOrgUnitData = Object.entries(orgUnitsData?.data || {}).map(
    ([key, value]) => ({
      id: Number(key),
      label: String(value),
    })
  );

  const {data: Audience_Type,isLoading: Audience_Type_Loading,isSuccess: Audience_Type_isSuccess,} = useSurveyConfiguration({ enable: true });
  const {data: SurveyCategoryTypeData,isLoading: SurveyCategoryTypeDataLoading,isSuccess: SurveyCategoryTypeDataIssucess,} = useGetCategoryType({ enable: true });

  useEffect(()=>{
    
    if(checkAddEditStatus ==='Edit'){
     setFormData((prev:any)=>({
      ...prev,
    CategoryName:Surveyrow?.name,
    Start_Date:Surveyrow?.StartDate,
    End_Data:Surveyrow?.EndDate,
    
    Survey_Category_Type:Surveyrow?.SurveyCatid,

    orgUnit:Surveyrow?.Orgunitid,
    IsMultiple:Surveyrow?.Multiple == false ? 'No' :'Yes',
    OutletType:Surveyrow?.OutletTypeId,
    // Status: Surveyrow?.Status === 'Active' ? 0 : 1,
    Status: Surveyrow?.Status === 'Active' ? 1 : 0,
    Audience_Type:Surveyrow?.AudienceType,
    MediaId:Surveyrow?.MediaId,
    shortCode:Surveyrow?.ShortCode,
     }))
    }
  },[checkAddEditStatus])

  const [formData, setFormData] = useState({
    CategoryName: "",
    Start_Date: "",
    End_Data: "",
    Survey_Category_Type: "",
    orgUnit: "",
    IsMultiple: "",
    OutletType: "",
    Status: "",
    Audience_Type: "",
    MediaId: "",
    shortCode:"",
  });
 const handleSubmit =(e:React.FormEvent<HTMLFormElement>)=>{
        e.preventDefault();
    
        if(checkAddEditStatus ==='Add'){
          
          const ReqBody = {
           SurveyName: formData.CategoryName ,
           StartDate:formData.Start_Date ,
           EndDate:formData.End_Data,
           SurveyCatid:Number(formData.Survey_Category_Type),
           Orgunitid: Number(formData.orgUnit),
           IsMultiple:formData.IsMultiple ,
           OutletTypeId:Number(formData.OutletType),
           Status: formData.Status === '0' ?'Inactive':'Active',
           AudienceType: formData.Audience_Type,
           ShortCode:formData.Audience_Type ==="Employee" ?"JW_Survey":formData.shortCode ,
           MediaId: Number(formData.MediaId),  
          }
          // console.log('ReqBody',ReqBody);
           AddSurvey(ReqBody);
          handleCancil();
    
          
        } 

        if(checkAddEditStatus === 'Edit'){           
          const ReqBody={
           SurveyId:Surveyrow?.SurveyId,
           SurveyName: formData.CategoryName ,
           StartDate:formData.Start_Date ,
           EndDate:formData.End_Data,
           SurveyCatid:Number(formData.Survey_Category_Type),
           Orgunitid: Number(formData.orgUnit),
           IsMultiple:formData.IsMultiple ,
           OutletTypeId:Number(formData.OutletType),
           Status: Number(formData.Status) === 0 ?'Inactive':'Active',
           AudienceType: formData.Audience_Type,
           ShortCode:formData.shortCode ,
           MediaId: Number(formData.MediaId),  
          }
          UpdateSurvey(ReqBody)
          handleCancil();
  
        }
 }

  const handleInput = (key: string, value: any) => {
    setFormData((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  const handleCancil = () => {
    setIsModalOpen(false);
    setCheckAddEditStatus("");
    setFormData({
      CategoryName: "",
      Start_Date: "",
      End_Data: "",
      Survey_Category_Type: "",
      orgUnit: "",
      IsMultiple: "",
      OutletType: "",
      Status: "",
      Audience_Type: "",
      MediaId: "",
      shortCode:''
    });
  };

  const handlefileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      try {
        const mediaId = await handleMedia(file);
          // console.log('mediaId----->',mediaId);
        setFormData((prev: any) => ({ ...prev, MediaId: mediaId }));
      } catch (error: any) {
        console.log("Media Upload failed", error);
      }
    }
  };
  return (
    <RouteModal
      isOpen={isModalOpen}
      toggle={() => {
        setIsModalOpen(!isModalOpen);
        handleCancil();
      }}
      title={title}
      // title="Add MTP"
      size="lg"
      content={
        <form onSubmit={handleSubmit}>
          <div className="row mb-0">
            <div className="d-flex justify-content-start gap-2">
              <div className="row mb-0 col-sm-12">
                <div className="col-sm-4">
                  {" "}
                  <CustomInput
                    placeholder="Name"
                    disabled={false}
                    onChange={(e: any) =>
                      handleInput("CategoryName", e.target.value)
                    }
                    value={formData.CategoryName}
                    required={true}
                    label="Name*"
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                    }}
                  />
                </div>
                <div className="col-sm-4">
                  <CustomInput
                    type="date"
                    placeholder="Start Date"
                    disabled={false}
                    onChange={(e: any) =>
                      handleInput("Start_Date", e.target.value)
                    }
                    value={formData.Start_Date}
                    required={true}
                    label="Start Date*"
                    style={{
                     border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                    }}
                  />

                </div>
                <div className="col-sm-4">
                  {" "}
                  <CustomInput
                    type="date"
                    placeholder="End Date"
                    disabled={false}
                    onChange={(e: any) =>
                      handleInput("End_Data", e.target.value)
                    }
                    value={formData.End_Data}
                    required={true}
                    label="End Date*"
                    style={{
                      border: "1px solid #e0e0e0",    
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-start gap-2">
              <div className="row mb-0 col-sm-12">
                <div className="col-sm-4">
                  <ReusableDropdown
                    options={
                      (!SurveyCategoryTypeDataLoading &&
                        SurveyCategoryTypeDataIssucess &&
                        SurveyCategoryTypeData?.formatedData) ||
                      []
                    }
                    value={formData.Survey_Category_Type}
                    onChange={(value: any) =>
                      handleInput("Survey_Category_Type", value)
                    }
                    DropdownHeading="Survey Category Type*"
                  />
                </div>

                <div className="col-sm-4">
                  {" "}
                  <ReusableDropdown
                    options={formattedOrgUnitData || []}
                    value={formData.orgUnit}
                    onChange={(value: any) => handleInput("orgUnit", value)}
                    DropdownHeading="Org Unit*"
                  />
                </div>
                <div className="col-sm-4">
                  {" "}
                  <ReusableDropdown
                    options={
                      (!Audience_Type_Loading &&
                        isSuccess &&
                        Audience_Type?.formatedData_IsMultiple) ||
                      []
                    }
                    value={formData.IsMultiple}
                    onChange={(value: any) => handleInput("IsMultiple", value)}
                    DropdownHeading="Is Multiple*"
                  />
                </div>
              </div>
            </div>

            <div style={{ height: 10 }} />
            <div className="d-flex justify-content-start gap-2">
              <div className="row mb-0 col-sm-12">
                <div className="col-sm-4">
                  {" "}
                  <ReusableDropdown
                    value={formData.OutletType}
                    options={
                      (!isLoading && isSuccess && data?.formatedata) || []
                    }
                    onChange={(value: any) => handleInput("OutletType", value)}
                    DropdownHeading="Outlet Type*"
                  />
                </div>

                <div className="col-sm-4">
                  {" "}
                  <ReusableDropdown
                    options={
                      (!statusLoading &&
                        StatusSuccess &&
                        StatusData?.formatedata) ||
                      []
                    }
                    value={formData.Status}
                    onChange={(value: any) => handleInput("Status", value)}
                    // onChange={(value: any) =>console.log(value)}
                    DropdownHeading="Status*"
                  />
                </div>
                <div className="col-sm-4">
                  {" "}
                  <ReusableDropdown
                    options={
                      (!Audience_Type_Loading && Audience_Type?.formatedData) ||
                      []
                    }
                    value={formData.Audience_Type}
                    onChange={(value: any) =>
                      handleInput("Audience_Type", value)
                    }
                    DropdownHeading="Audience Type*"
                  />
                </div>
              </div>
            </div>
               
            <div className="col-sm-12">
                  {" "}
                  <CustomInput
                    disabled={formData.Audience_Type ==="Employee" ?true:false}
                    onChange={(e: any) =>
                      handleInput("shortCode", e.target.value)
                    }
                    value={formData.Audience_Type ==="Employee" ?"JW_Survey": formData.shortCode}
                    required={formData.Audience_Type ==="Customer" ?false:true}
                    label="Short Code*"
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      padding: "10px",
                      fontSize: "14px",
                    }}
                  />
                </div>

            <div style={{ height: 10 }} />

            <label className="mt-2"  style={{ fontWeight: "500" }}>
             {checkAddEditStatus ==="Edit"?'Uploaded media':'Upload Media'}
            </label>
            <input
              type="file"
               id="mediaUpload"
              className="form-control"
              onChange={(e: any) => handlefileChange(e)}
              style={{
                border: "2px solid #EDEDED",
                borderRadius: "8px",
                padding: "13px",
                fontSize: "14px",
                color: "red",
                width:'226px',
                height:'43px'
              }}
            />

             {formData.MediaId && ( 
              <div 
                style={{
                position: "relative",
                marginTop: "10px",
                width: "fit-content",
              }}>

                <img
                  src={
                    formData.MediaId
                      ? `${BASE_URL}${formData.MediaId}`
                      : "https://via.placeholder.com/100?text=No+Image"
                  }
                  alt={formData.MediaId ? "Upload Media" : "Dummy"}
                  style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  }}
                />
                 <span
                    onClick={() => {
                     setFormData((prevState: any) => ({
                                    ...prevState,
                                    MediaId: "",
                                    mediaFile: null,
                                  }));
                
                                  // ✅ Clear input value
                                  const fileInput = document.getElementById(
                                    "mediaUpload"
                                  ) as HTMLInputElement;
                                  if (fileInput) fileInput.value = "";
                                }}
                                style={{
                                  position: "absolute",
                                  top: "-8px",
                                  right: "-8px",
                                  background: "#fff",
                                  border: "1px solid #ccc",
                                  borderRadius: "50%",
                                  padding: "2px 6px",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                              >
                                <FaTrash size={14} color="red" />
                  </span>
                </div>

              )
              } 

            {/* Edit Case */}

            {/* {checkAddEditStatus === "Edit" && (
              <div className="col-md-6" style={{ marginBottom: "10px" }}>
              
                <img
                  src={
                    formData.MediaId
                      ? `${BASE_URL}${formData.MediaId}`
                      : "https://via.placeholder.com/100?text=No+Image"
                  }
                  alt={formData.MediaId ? "Upload Media" : "Dummy"}
                  style={{
                    width: "100px",
                    borderRadius: "8px",
                  }}
                />
              </div>
            )}   */}

            <div style={{ height: 20 }} />
            <div className="d-flex justify-content-start gap-2">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
              >
                {checkAddEditStatus === "Add" ? "Submit" : "Update"}
              </Btn>
              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={() =>{handleCancil();}}
              >
                Cancel
              </Btn>
            </div>
          </div>
        </form>
      }
    />
  );
};

export default SurveyAddAndEditModal;
